import { render, staticRenderFns } from "./AquassistPage.vue?vue&type=template&id=1bfb4370&scoped=true"
import script from "./AquassistPage.vue?vue&type=script&lang=js"
export * from "./AquassistPage.vue?vue&type=script&lang=js"
import style0 from "./AquassistPage.vue?vue&type=style&index=0&id=1bfb4370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb4370",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
